/* eslint-disable prettier/prettier */
export const GET_ALL_INVOICES = "GET_ALL_INVOICES";
export const GET_PAYROLL = "GET_PAYROLL";
export const GENERATE_INVOICES = "GENERATE_INVOICES";
export const GENERATE_PAYROLL_ITEM = "GENERATE_PAYROLL_ITEM";
